import { render, staticRenderFns } from "./PersonData.vue?vue&type=template&id=335be780&"
import script from "./PersonData.vue?vue&type=script&lang=js&"
export * from "./PersonData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports